"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PermissionSetSelector = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _DropDown = _interopRequireDefault(require("@civicplus/preamble/lib/DropDown/DropDown"));

var _react = _interopRequireWildcard(require("react"));

var _sdk = require("@civicplus/hcms-api-sdk/dist/sdk");

var _TypeGuards = require("../Utility/TypeGuards");

var _classnames = _interopRequireDefault(require("classnames"));

var _Alert = require("../Utility/Alert");

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

var _Config = require("../Utility/Config");

var _get = _interopRequireDefault(require("lodash/get"));

var PermissionSetSelector = function PermissionSetSelector(props) {
  var _props$helperText;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sets = _useState2[0],
      setSets = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  (0, _react.useEffect)(function () {
    var existing = sets.find(function (w) {
      var _props$value;

      return w.id === ((0, _TypeGuards.isString)(props.value) ? props.value : (_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.id);
    });
    setValue(existing);
  }, [props.value, sets]);
  (0, _react.useEffect)(function () {
    function load() {
      return _load.apply(this, arguments);
    }

    function _load() {
      _load = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var config, service, sets, items;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = props.config;

                if (props.isAsset) {
                  config = (0, _Config.includeFlow)(props.config, {
                    "X-ResolveFlow-Assets": "true"
                  });
                } else if (props.contentTypeName) {
                  config = (0, _Config.includeFlow)(props.config, {
                    "X-ResolveFlow-Contents": props.contentTypeName
                  });
                }

                service = new _sdk.PermissionSetApi(config);
                _context.next = 5;
                return service.getPermissionSets(props.config.appName);

              case 5:
                sets = _context.sent;
                items = sets.items.filter(function (permissionSet) {
                  var path = props.contentTypeName ? "content/".concat(props.contentTypeName) : "assets";

                  if (props.isCreating) {
                    var canCreate = !!(0, _get["default"])(permissionSet._links, "".concat(path, "/create.href"));
                    var canPublish = !!(0, _get["default"])(permissionSet._links, "".concat(path, "/create/publish.href"));
                    return canCreate || canPublish;
                  } else {
                    var canUpdate = !!(0, _get["default"])(permissionSet._links, "".concat(path, "/update.href"));
                    return canUpdate;
                  }
                }); //Currently the sdk does not have the orderBy prop. This order by can be removed once that is implemented on the sdk

                setSets((0, _sortBy["default"])(items, [function (p) {
                  return p.name.toLowerCase();
                }]));

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _load.apply(this, arguments);
    }

    (0, _Alert.alertOnError)("Failed to load permission sets", load);
  }, [props.config, props.contentTypeName, props.isAsset, props.isCreating]);
  return /*#__PURE__*/_react["default"].createElement(_DropDown["default"], {
    isInDialog: props.isInDialog,
    className: (0, _classnames["default"])("prmbl-permissionSetSelector", props.className),
    label: "Permission Set",
    value: value != null ? {
      label: value.name,
      id: value.id
    } : undefined,
    helperText: (_props$helperText = props.helperText) !== null && _props$helperText !== void 0 ? _props$helperText : "Select a Permission Set to begin modifying your item.",
    onChange: function onChange(e) {
      var _props$onChange;

      var set = sets.find(function (w) {
        return w.id === e.value;
      });
      setValue(set);
      set && ((_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, set));
    },
    disabled: props.disabled,
    options: sets.map(function (s) {
      return {
        label: s.name,
        value: s.id
      };
    })
  });
};

exports.PermissionSetSelector = PermissionSetSelector;